import { type FunctionComponent } from "react";
import { makeRipple } from "@/react/core/ripple-utils.ts";
import { onlineOrder0 } from "@/react/DeliveryManagementView/DeliveryManagementLogic.tsx";
import _ from "lodash";
import { LL0 } from "@/react/core/I18nService.tsx";

interface MoreActionsProps {
  onClose?: () => void;
  onViewMap?: () => void;
  onViewOrderDetail?: () => void;
  onPrint?: () => void;
  onAssignDriver?: () => void;
  onReassignDriver?: () => void;
  onCompleteOrder?: () => void;
  onViewOrderCancellation?: () => void;
  onCancelOrder?: () => void;
}

const MoreActions: FunctionComponent<MoreActionsProps> = ({
  onClose,
  onViewMap,
  onViewOrderCancellation,
  onCancelOrder,
  onViewOrderDetail,
  onCompleteOrder,
  onPrint,
  onAssignDriver,
  onReassignDriver
}) => {

  return (
    <>
      <div className="w-[400px] h-auto font-mulish overflow-hidden rounded-[8px] bg-white">
        <div className="flex flex-1  px-3 py-2 rounded-t-[8px] border-b border-[#e0e0e0]">
          <div className="flex-1 font-bold text-[16px] text-[#0051c1]">
            {LL0().onlineOrder.settings.orderNumber()} #112
          </div>
          <img src="/icon-close-popup-icon--grey@2x.png" className="w-[22px] h-[22px]" alt="" onClick={onClose}/>
        </div>
        <div className="flex flex-col gap-2 p-3">
          <div
            className="flex items-center px-2 py-2.5 gap-2 border border-[#bcbcbc] rounded"
            ref={makeRipple}
            onClick={onViewMap}
          >
            <img src="/view-map-icon@2x.png" className="w-[18px] h-[18px]" alt=""/>
            <span className="font-semibold text-[14px] md:text-[12px]">{LL0().deliveryManagement.viewMap()}</span>
          </div>
          <div
            className="flex items-center px-2 py-2.5 gap-2 border border-[#bcbcbc] rounded"
            ref={makeRipple}
            onClick={onViewOrderDetail}
          >
            <img src="/view-order-detail-icon@2x.png" className="w-[18px] h-[18px]" alt=""/>
            <span className="font-semibold text-[14px] md:text-[12px]">{LL0().deliveryManagement.viewOrderDetail()}</span>
          </div>
          <div
            className="flex items-center px-2 py-2.5 gap-2 border border-[#bcbcbc] rounded"
            ref={makeRipple}
            onClick={onPrint}
          >
            <img src="/print-icon@2x.png" className="w-[18px] h-[18px]" alt=""/>
            <span className="font-semibold text-[14px] md:text-[12px]">{LL0().ui.print()}</span>
          </div>
          {!_.isEmpty(onlineOrder0()?.driverInfo) ?
            <div
              className="flex items-center px-2 py-2.5 gap-2 border border-[#bcbcbc] rounded"
              ref={makeRipple}
              onClick={onAssignDriver}
            >
              <img src="/reassign-driver-icon@2x.png" className="w-[18px] h-[18px]" alt="" />
              <span className="font-semibold text-[14px] md:text-[12px]">{LL0().deliveryManagement.reassignDriver()}</span>
            </div> :
            <div
              className="flex items-center px-2 py-2.5 gap-2 border border-[#bcbcbc] rounded"
              ref={makeRipple}
              onClick={onAssignDriver}
            >
              <img src="/assign-driver-icon@2x.png" className="w-[18px] h-[18px]" alt="" />
              <span className="font-semibold text-[14px] md:text-[12px]">{LL0().deliveryManagement.assignDriver()}</span>
            </div>
          }
          <div
            className="flex items-center px-2 py-2.5 gap-2 border border-[#bcbcbc] rounded"
            ref={makeRipple}
            onClick={onCompleteOrder}
          >
            <img src="/complete-order-icon@2x.png" className="w-[18px] h-[18px]" alt="" />
            <span className="font-semibold text-[14px] md:text-[12px]">{LL0().onlineOrder.completeOrder()}</span>
          </div>
          {/*<div*/}
          {/*  className="flex items-center px-2 py-2.5 gap-2 border border-[#bcbcbc] rounded"*/}
          {/*  ref={makeRipple}*/}
          {/*  onClick={onViewOrderCancellation}*/}
          {/*>*/}
          {/*  <img src="/view-order-cancelation-icon@2x.png" className="w-[18px] h-[18px]" alt=""/>*/}
          {/*  <span className="font-semibold text-[14px] md:text-[12px]">View order cancellation</span>*/}
          {/*</div>*/}
          <div
            className="flex items-center px-2 py-2.5 gap-2 border border-[#bcbcbc] rounded"
            ref={makeRipple}
            onClick={onCancelOrder}
          >
            <img src="/cancel-order-icon@2x.png" className="w-[18px] h-[18px]" alt=""/>
            <span className="font-semibold text-[14px] md:text-[12px]">{LL0().onlineOrder.cancelOrder()}</span>
          </div>
        </div>
      </div>
    </>
  )
}

export default MoreActions;